import { render, staticRenderFns } from "./PaymentMethodsWithValidation.vue?vue&type=template&id=64b4a794&lang=pug&"
import script from "./PaymentMethodsWithValidation.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodsWithValidation.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodsWithValidation.vue?vue&type=style&index=0&id=64b4a794&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports